export default __webpack_public_path__ + "static/media/Templat3.1cb05031.png";